@import "~@govbr-ds/core/src/components/avatar/avatar";

:host {
  display: inline-block;

  .br-avatar .content.text-pure-0 {
    background-color: var(--avatar-text-background-color);
  }
}

:host([density="small"]) .avatar-icon {
  margin-top: 0.7em;
}

:host([density="medium"]) .avatar-icon {
  margin-top: 0.95em;
}

:host([density="large"]) .avatar-icon {
  margin-top: 0.65em;
}
